import { render, staticRenderFns } from "./FileUploadWrapper.vue?vue&type=template&id=5ff0c8ce"
import script from "./FileUploadWrapper.vue?vue&type=script&lang=js"
export * from "./FileUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports